import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RetailerTypeDetailsResponse, RetailerTypesService } from '@src/app/shared/backend/clients';
import { ConfirmationService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { Actions } from '@src/app/shared/backend/auth/Action';
import { DialogReasonComponent } from '@src/app/shared/components/dialog-reason/dialog-reason.component';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-view-retailer-type',
    templateUrl: './view-retailer-type.component.html',
    styleUrl: './view-retailer-type.component.scss',
    host: {
        class: 'app-view-retailer-type'
    },
    providers: [ConfirmationService],
    standalone: false
})
export class ViewRetailerTypeComponent extends BaseViewComponent implements OnInit {
  @ViewChild('dialog') dialog: DialogReasonComponent | undefined;

  delete: boolean = false;
  allowModifyRetailerType: boolean = false;
  retailerTypeId: number = 0;
  retailerType: RetailerTypeDetailsResponse = {
    id: 0,
    name: '',
    code: ''
  };

  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private retailerTypesService: RetailerTypesService) {
      super();
  }

  async ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    this.route.params.subscribe(async params => {
      this.retailerTypeId = params['retailerTypeId'];
      if (this.retailerTypeId) {
        await this.get();
      }
    });

    this.delete = await this.permissionService.hasActionPermissions(Actions.delete);
    this.allowModifyRetailerType = await this.permissionService.hasActionPermissions(Actions.modify_retailertypes);
  }

  async showDeleteDialog(): Promise<void> {
    const deleteCheckResponses = await firstValueFrom(this.retailerTypesService.apiRetailerTypesDeleteCheckBatchPost([this.retailerTypeId]));

    this.dialog?.show(deleteCheckResponses);
  }

  async deleteRetailerType(doDelete: boolean): Promise<void> {
    if (doDelete) {
      await firstValueFrom(this.retailerTypesService.apiRetailerTypesDeleteIdDelete(this.retailerTypeId));
      this.router.navigate([`/retailer-types`]);
    }
  }

  override async get() {
    try {
      this.retailerType = await firstValueFrom(this.retailerTypesService.apiRetailerTypesDetailsIdGet(this.retailerTypeId));
    } catch (error) {
      console.error('Error fetching retailerType data:', error);
    }
  }

  goToEditRetailerType() {
    this.router.navigate([`/retailer-types/${this.retailerTypeId}/edit`]);
  }

}
